// LoginButtonTest.js

import React from "react";
import { MsalProvider } from "@azure/msal-react";
import { PublicClientApplication } from "@azure/msal-browser";
import { msalConfig } from "../authConfig"; // Azure AD Config bilgileri
import LoginButton from "./LoginButton";


const pca = new PublicClientApplication(msalConfig);

const LoginButtonTest = () => {
  return (
    <MsalProvider instance={pca}>
      <LoginButton />
    </MsalProvider>
  );
};

export default LoginButtonTest;
